import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { cn } from '@/lib/ui/utils';
type DebateBubbleTail = 'brand-left' | 'cyan-right';
const TAIL_FILL_CLASS: Record<DebateBubbleTail, string> = {
  'brand-left': 'fill-[var(--brand-300)]',
  'cyan-right': 'fill-outcome-cyan-text'
};
function DebateBubbleTailGraphic(t0) {
  const $ = _c(10);
  const {
    tail
  } = t0;
  if (tail === "brand-left") {
    const t1 = TAIL_FILL_CLASS[tail];
    let t2;
    if ($[0] !== t1) {
      t2 = cn("pointer-events-none absolute left-2 top-[calc(100%-5px)] z-0 h-[13px] w-4", t1);
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <path d="M0 12.36C4.14 10.37 4.25 3.85 3.78 0H15.96C16.99 10.59 4.38 15.25 0 12.36Z" />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== t2) {
      t4 = <svg aria-hidden="true" className={t2} data-debate-bubble-tail="" viewBox="0 0 16.019 13.2036">{t3}</svg>;
      $[3] = t2;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  const t1 = TAIL_FILL_CLASS[tail];
  let t2;
  if ($[5] !== t1) {
    t2 = cn("pointer-events-none absolute right-2 top-[calc(100%-5px)] z-0 h-[11px] w-[14px] -scale-y-100 rotate-180", t1);
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M0 10.6C3.55 8.89 3.64 3.3 3.24 0H13.68C14.56 9.08 3.75 13.07 0 10.6Z" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2) {
    t4 = <svg aria-hidden="true" className={t2} data-debate-bubble-tail="" viewBox="0 0 13.7306 11.3174">{t3}</svg>;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function DebateBubble(t0) {
  const $ = _c(19);
  const {
    label,
    className,
    bubbleClassName,
    rotationClassName,
    tail,
    testId
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("absolute", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rotationClassName) {
    t2 = cn("relative inline-block transform-gpu backface-hidden [filter:drop-shadow(0_6px_12px_var(--shadow-ambient))]", rotationClassName);
    $[2] = rotationClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== bubbleClassName) {
    t3 = cn("relative z-10 whitespace-nowrap rounded-full px-3 py-1.5 text-body font-medium text-white", bubbleClassName);
    $[4] = bubbleClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label || $[7] !== t3) {
    t4 = <div className={t3}>{label}</div>;
    $[6] = label;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== tail) {
    t5 = <DebateBubbleTailGraphic tail={tail} />;
    $[9] = tail;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t6 || $[17] !== testId) {
    t7 = <div className={t1} data-testid={testId}>{t6}</div>;
    $[15] = t1;
    $[16] = t6;
    $[17] = testId;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}